import { TFieldProps } from 'types';

export const enFields: TFieldProps[] = [{
  type: TFieldProps.type.ImageUpload,
  name: ['enValues', 'imageMetadataId'],
  label: 'Hero Image',
  entityType: 'OFFER',
  rules: [{
    message: 'Hero Image is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.Text,
  name: ['enValues', 'title'],
  label: 'Title',
  rules: [{
    max: 256,
    message: 'Max length 255',
  }],
}, {
  type: TFieldProps.type.Text,
  name: ['enValues', 'displayName'],
  label: 'Name in app',
  rules: [{
    message: 'Name in app is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.Textarea,
  name: ['enValues', 'description'],
  label: 'Description',
  rules: [{
    message: 'Description is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.Textarea,
  name: ['enValues', 'termsAndConditions'],
  label: 'T&C',
  tooltip: 'Placeholders $EFFECTIVE_FROM$, $EFFECTIVE_TO$, $REGIONS$ are supported',
  rules: [{
    message: 'T&C is required!',
    required: true,
  }],
  autoSize: {
    minRows: 5,
    maxRows: 15,
  },
}, {
  type: TFieldProps.type.Textarea,
  name: ['enValues', 'displayTermsAndConditions'],
  label: 'T&C Display',
  readOnly: true,
  allowClear: false,
  autoSize: {
    minRows: 5,
    maxRows: 15,
  },
}];

export const frFields: TFieldProps[] = [{
  type: TFieldProps.type.ImageUpload,
  name: ['frValues', 'imageMetadataId'],
  label: 'Hero Image',
  entityType: 'OFFER',
  rules: [{
    message: 'Hero Image is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.Text,
  name: ['frValues', 'title'],
  label: 'Title',
  rules: [{
    max: 256,
    message: 'Max length 255',
  }],
}, {
  type: TFieldProps.type.Text,
  name: ['frValues', 'displayName'],
  label: 'Name in app',
  rules: [{
    message: 'Name in app is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.Textarea,
  name: ['frValues', 'description'],
  label: 'Description',
  rules: [{
    message: 'Description is required!',
    required: true,
  }],
}, {
  type: TFieldProps.type.Textarea,
  name: ['frValues', 'termsAndConditions'],
  label: 'T&C',
  tooltip: 'Placeholders $EFFECTIVE_FROM$, $EFFECTIVE_TO$, $REGIONS$ are supported',
  rules: [{
    message: 'T&C is required!',
    required: true,
  }],
  autoSize: {
    minRows: 5,
    maxRows: 15,
  },
}, {
  type: TFieldProps.type.Textarea,
  name: ['frValues', 'displayTermsAndConditions'],
  label: 'T&C Display',
  readOnly: true,
  allowClear: false,
  autoSize: {
    minRows: 5,
    maxRows: 15,
  },
}];
